<template>
<div class="video-player">
  
  <!-- Background Video -->
  <video class="fullscreen-video" autoplay muted loop id="video">
    <source src="~@/assets/videos/video.mp4" type="video/mp4">
    {{ $t('video-player.video-error-message') }}Your browser does not support the video tag.
  </video>

  <!-- Video Overlay -->
  <div class="video-overlay"></div>

  <!-- Title name -->
  <div class="name-container">
    <h2 class="text-name">Jérffeson Jésus</h2>
    <h3 class="text-role">{{ $t('video-player.role') }}</h3>
  </div>

</div>
</template>

<style scoped>
@import '~/src/assets/css/VideoPlayerStyle.scss';
</style>